define([
  "jquery",
  "globals",
  "postal",
  "knockout"],
function($, globals, postal, ko) {

  "use strict";

  var getQueryParams = function(stringToParse, key) {
    if (stringToParse === undefined) {
      stringToParse = window.location.search;
    } else {
      stringToParse = stringToParse.substr(stringToParse.lastIndexOf("?"));
    }
    var urlParams = {};
    var match;
    var pl = /\+/g;
    var search = /([^&=]+)=?([^&]*)/g;
    var decode = function(s) {
      return decodeURIComponent(s.replace(pl, " "));
    };
    stringToParse = stringToParse.substring(1);
    while (match = search.exec(stringToParse)) {
      urlParams[decode(match[1])] = decode(match[2]);
    }
    if (key !== undefined) {
      if (key in urlParams) {
        // key = Object.keys(urlParams)[0];
        var obj = {};
        obj[key] = urlParams[key]
        return obj;
      } else {
        return false;
      }
    } else {
      return urlParams;
    }
  };

  var urlExists = function(url) {
    var http = new XMLHttpRequest();
    http.open("HEAD", url, false);
    http.send();
    return http.status !== 404;
  };

  Array.prototype.diff = function(a) {
    return $.grep(this, function(item) {
      return $.inArray(item, a) < 0;
    });
  };

  // Extends Function to return constructor name
  // Usage: functionObj.name
  if (Function.prototype.name === undefined && Object.defineProperty !== undefined) {
    Object.defineProperty(Function.prototype, 'name', {
        get: function() {
            var funcNameRegex = /function\s([^(]{1,})\(/;
            var results = (funcNameRegex).exec((this).toString());
            return (results && results.length > 1) ? results[1].trim() : "";
        },
        set: function(value) {}
    });
  }

  $.getQueryString = function() {
      var result = {};
      
    var tokenizedUrl = decodeURIComponent(window.location.href.split("#")[0]).split("?");
    var queryString = tokenizedUrl[tokenizedUrl.length - 1];
    var re = /([^&=]+)=([^&]*)/g;
    var m;

      //HACK -- Filters can totally have ampersands in them.  This makes the regex above cry, so we temporarily replace filter ampersands with a series of underscores
    if (queryString.indexOf("filters")!== -1) {
        var original = queryString.split("filters")[1].split('}')[0];
        var replaced = original.replace("&", "___");
        queryString = queryString.replace(original, replaced);
    }
        
    // HACK -- For vanity URLs we populate a script variable with the expected querystring
    if (typeof window.originalQueryString !== "undefined") {
      while (m = re.exec(window.originalQueryString)) {
        result[decodeURIComponent(m[1])] = decodeURIComponent(m[2]).replace(/\+/g, " ");
      }
    }
    // Override with real querystrings
    while (m = re.exec(queryString)) {
        //Replace those 
        var originalComponent = decodeURIComponent(m[2]);
        var replacedComponent = originalComponent.replace("___", "&");
      result[decodeURIComponent(m[1])] = replacedComponent;
    }
    return result;
  };

  var toSlug = function(text) {
    text = (!text) ? "" : text;
    text = text.toString()
      .replace(/\s+/g, "-")           // Replace spaces with -
      .replace(/[^\w\-]+/g, "")       // Remove all non-word chars
      .replace(/[_\s]+/g, "-")
      .replace(/([A-Z])/g, "-$1")
      .replace(/\-\-+/g, "-")         // Replace multiple - with single -
      .replace(/^-+/, "")             // Trim - from start of text
      .replace(/-+$/, "").toLowerCase();
    return text;
  };

  $.getQueryStringValue = function(key) {
    if (key === undefined) {
      return;
    }
    var result = {};
    var tokenizedUrl = decodeURIComponent(window.location.href.split("#")[0]).split("?");
    var queryString = tokenizedUrl[tokenizedUrl.length - 1];
    var re = /([^&=]+)=([^&]*)/g;
    var m;
    //HACK -- For vanity URLs we populate a script variable with the expected querystring
    if (typeof window.originalQueryString !== "undefined") {
      while (m = re.exec(window.originalQueryString)) {
        result[m[1].toLowerCase()] = m[2];
      }
    }
    while (m = re.exec(queryString)) {
      result[decodeURIComponent(m[1].toLowerCase())] = decodeURIComponent(m[2]);
    }
    return result[key.toLowerCase()];
  };

  //http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
  $.getQueryStringWithVanillaBehavior = function () {
    var a = window.location.search.substr(1).split('&');
    if (a == "") return {};
    var b = {};
    for (var i = 0; i < a.length; ++i)
    {
        var p=a[i].split('=', 2);
        if (p.length == 1)
            b[p[0]] = "";
        else
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
    }
    return b;
  };

  $.tryParseInt = function(str, defaultValue) {
    var retValue = defaultValue;
    if (str !== null && str !== undefined) {
      if (str.length > 0) {
        if (!isNaN(str)) {
          retValue = parseInt(str, 10);
        }
      }
    }
    return retValue;
  };

  String.prototype.isInt = function() {
    var value = this.valueOf().replace(/,/, "");
    return !isNaN(parseFloat(value)) && isFinite(value);
  };

  var jq_throttle;

  $.throttle = jq_throttle = function(delay, no_trailing, callback, debounce_mode) {

    // After wrapper has stopped being called, this timeout ensures that
    // `callback` is executed at the proper times in `throttle` and `end`
    // debounce modes.
    var timeout_id;

    // Keep track of the last time `callback` was executed.
    var last_exec = 0;

    // `no_trailing` defaults to falsy.
    if (typeof no_trailing !== "boolean") {
      debounce_mode = callback;
      callback = no_trailing;
      no_trailing = undefined;
    }

    // The `wrapper` function encapsulates all of the throttling / debouncing
    // functionality and when executed will limit the rate at which `callback`
    // is executed.
    var wrapper = function() {
      var self = this;
      var elapsed = +new Date() - last_exec;
      var args = arguments;

      // Execute `callback` and update the `last_exec` timestamp.
      function exec() {
        last_exec = +new Date();
        callback.apply(self, args);
      }

      // If `debounce_mode` is true(at_begin) this is used to clear the flag
      // to allow future `callback` executions.
      function clear() {
        timeout_id = undefined;
      }

      if (debounce_mode && !timeout_id) {
        // Since `wrapper` is being called for the first time and
        // `debounce_mode` is true(at_begin), execute `callback`.
        exec();
      }

      // Clear any existing timeout.
      timeout_id && clearTimeout(timeout_id);

      if (debounce_mode === undefined && elapsed > delay) {
        // In throttle mode, if `delay` time has been exceeded, execute
        // `callback`.
        exec();

      } else if (no_trailing !== true) {
        // In trailing throttle mode, since `delay` time has not been
        // exceeded, schedule `callback` to execute `delay` ms after most
        // recent execution.
        //
        // If `debounce_mode` is true(at_begin), schedule `clear` to execute
        // after `delay` ms.
        //
        // If `debounce_mode` is false(at end), schedule `callback` to
        // execute after `delay` ms.
        timeout_id = setTimeout(debounce_mode ? clear : exec, debounce_mode === undefined ? delay - elapsed : delay);
      }
    };

    // Set the guid of `wrapper` function to the same of original callback, so
    // it can be removed in jQuery 1.4+ .unbind or .die by using the original
    // callback as a reference.
    if ($.guid) {
      wrapper.guid = callback.guid = callback.guid || $.guid++;
    }

    // Return the wrapper function.
    return wrapper;
  };

  $.debounce = function(delay, at_begin, callback) {
    return callback === undefined ?
      jq_throttle(delay, at_begin, false) :
      jq_throttle(delay, callback, at_begin !== false);
  };

  function isValidEmail(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
  }

  var isBound = function(element) {
    return !!ko.dataFor(element);
  };

  return {
    getQueryParams : getQueryParams,
    toSlug: toSlug,
    urlExists : urlExists,
    isValidEmail: isValidEmail,
    isBound: isBound
  };

});
